import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    scrollbarWidth: 0,
  },
  reducers: {
    setScrollbarWidth: (state, action: PayloadAction<number>) => {
      state.scrollbarWidth = action.payload;
    },
  },
});

export { uiSlice };
